import { useState } from "react";
import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "../supplier/SinglePartition.scss";
import { Navigation, Pagination } from "swiper";
import SinglePartition from "../supplier/SinglePartition.jsx";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import vegetable from "../../assets/images/vegetable.png";
import plus from "../../assets/images/Icon feather-plus.png";

import SupplierContext from "context/SupplierContext";
export default function PopularProducts({ data }) {
  const { setProduct } = useContext(SupplierContext);
  // const { setProduct } = useContext(SupplierContext);

  return (
    <div className="popular mt-5" style={{ backgroundColor: "#CFCCDA" }}>
      <Swiper
        navigation={true}
        modules={[Navigation]}
        spaceBetween={30}
        // pagination={{
        //   clickable: true
        // }}
        // slidesPerView={"auto"}
        // centeredSlides={true}
        breakpoints={{
          1200: {
            slidesPerView: 5,
            spaceBetween: 20
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          600: {
            slidesPerView: 2.5,
            spaceBetween: 20
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1.5,
            spaceBetween: 20
          }
        }}
        className="mySwiper SinglePartition"
      >
        <SwiperSlide>
          <div className="position-relative slide-one">
            <h4 className="mt-5 ms-5">محبوب ترین کالاها</h4>
            <img
              src={vegetable}
              style={{
                width: "400px",
                height: "330px",
                bottom: "0",
                right: "-120px"
              }}
            />
          </div>
        </SwiperSlide>

        {data.length > 0 &&
          data.map((value, index) => {
            return (
              <SwiperSlide>
                <a
                  className="card product"
                  style={{ cursor: "pointer" }}
                  key={index}
                  onClick={e => setProduct(value)}
                  data-bs-toggle="modal"
                  data-bs-target="#singleproduct"
                >
                  <div className="pic position-relative text-center ">
                    <div
                      className="img1 mt-3 text-center"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <img
                        src={`http://sabadi.tatdemo.ir/${value.info.supplier_cover_img}`}
                        // alt="cover"
                        style={{
                          maxWidth: "170px",
                          height: "160px",
                          borderRadius: "10px"
                        }}
                      />
                    </div>
                  </div>
                  <div className="plus">
                    <img src={plus} alt="plus" />
                  </div>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%"
                    }}
                  >
                    <div className="title text-center">{value.info.title}</div>
                    <div className="d-flex justify-content-around w-100 mt-2">
                      <div className="cost">
                        {addCommas(value.info.default_price)} تومان
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            );
          })}
      </Swiper>

      {/* <div
        className="d-flex  justify-content-between shopStyle mt-5"
        style={{ backgroundColor: "#CFCCDA" }}
      >
        <div className="position-relative " style={{ width: "20%" }}>
          <h4 className="mt-5 ms-5">محبوب ترین کالاها</h4>
          <img
            src={vegetable}
            className="position-absolute"
            style={{
              width: "400px",
              height: "330px",
              bottom: "0",
              right: "-120px"
            }}
          />
        </div> */}

      {/* <div className="SinglePartition " style={{ width: "80%" }}>
          <SinglePartition data={fish} />
        </div> */}
      {/* </div> */}
    </div>
  );
}
